import { ENDPOINTS, getFullUrl } from "../config";
import { Order } from "./types";

export class AdminOrderService {
  static getToken(): string | null {
    return localStorage.getItem("token");
  }
  static getRole(): string | null {
    return localStorage.getItem("auth_user");
  }

  static async getAdminOrdersListing(
    page = 1,
    pageSize = 10,
    filters: {
      hasPrescription?: boolean;
      orderStatus?: "COMPLETED" | "PENDING_PATIENT" | "DELIVERY_ASSIGNED" | "CANCELLED" | "CLINIC_ASSIGNED";
      orderType?: "PRESCRIPTION" | "LAB";
      isLabtestOrder?: boolean;
      clinicId?: string;
      searchText?: string;
    }
  ): Promise<{
    success: boolean;
    message?: string;
    data?: {
      pagination: {
        totalCount: number;
        totalPages: number;
        page: number;
        pageSize: number;
      };
      orders: Order[];
    };
  }> {
    try {
      const filtersObj: Record<string, any> = {};
      if (filters.hasPrescription !== undefined) {
        filtersObj.hasPrescription = filters.hasPrescription;
      }
      if (filters.orderStatus) {
        filtersObj.orderStatus = filters.orderStatus;
      }
      if (filters.orderType) {
        filtersObj.orderType = filters.orderType;
      }

      if (filters.isLabtestOrder === true) {
        filtersObj.isLabtestOrder = filters.isLabtestOrder;
      }
      if (filters.clinicId !== undefined) {
        filtersObj.clinicId = filters.clinicId;
      }
      if (filters.searchText !== undefined) {
        filtersObj.searchText = filters.searchText;
      }

      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        filters: JSON.stringify(filtersObj),
      });

      const url = `${getFullUrl(ENDPOINTS.ORDERS.GETORDERLISTING)}?${params.toString()}`;

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch orders:", error);
      throw error;
    }
  }

  static async getAdminOrderDetails(orderId: number) {
    try {
      const response = await fetch(
        getFullUrl(ENDPOINTS.ORDERS.GETORDERDETAILS.replace(":id", orderId.toString())),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("details of medicine", data);
      return data;
    } catch (error) {
      console.error("Failed to fetch order details:", error);
      throw error;
    }
  }

  static async getAdminPatientDetailsById(patientId: string) {
    try {
      const response = await fetch(
        getFullUrl(`${ENDPOINTS.ORDERS.GETPATIENTDETAILS}?patientId=${patientId}`),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("details of medicine", data);
      return data;
    } catch (error) {
      console.error("Failed to fetch order details:", error);
      throw error;
    }
  }

  static async getAdminProductListing(page = 1, pageSize = 10, searchText = "", clinicId?:string,completeData?:boolean) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
      });

      if (searchText) {
        params.append("searchText", searchText);
      }

      if (clinicId) {
        params.append("clinicId", clinicId);
      }

      if (completeData) {
        params.append("isCompleteData", completeData.toString());
      }

      const url = `${getFullUrl(ENDPOINTS.STOCKS.GETALLINVENTRYLIST)}?${params.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch order details:", error);
      throw error;
    }
  }

  static async getClinicProductListing(page = 1, pageSize = 10, searchText = "", clinicId?:string) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
      });

      if (searchText) {
        params.append("searchText", searchText);
      }

      if (clinicId) {
        params.append("clinicId", clinicId);
      }

      const url = `${getFullUrl(ENDPOINTS.INVENTORY.GETCLINICSTOCK)}?${params.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch order details:", error);
      throw error;
    }
  }

  static async processOrderSuccess(
    orderId: number,
    orderTotal: number,
    hasPrescription: boolean,
    imageFile?: File | string | null,
    doctorName?:string
  ) {
    try {
      const formData = new FormData();
      formData.append("orderTotal", orderTotal.toString());
      formData.append("hasPrescription", "true");
      if(doctorName){
        formData.append("doctorName",doctorName);
      }
      console.log("Processing order with image type:", typeof imageFile);

      if (imageFile instanceof File) {
        console.log("Appending File object to FormData");
        formData.append("image", imageFile);
      } else if (typeof imageFile === "string") {
        if (imageFile.startsWith("data:")) {
          console.log("Converting base64 string to Blob");
          try {
            const blob = await fetch(imageFile).then((res) => res.blob());
            formData.append("image", blob, "admin_prescription.png");
          } catch (error) {
            console.error("Failed to convert base64 to blob:", error);
            throw new Error("Invalid prescription image format");
          }
        } else {
          // Handle URL string
          formData.append("image", imageFile);
        }
      }

      console.log("FormData contents:");
      for (const [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const response = await fetch(
        getFullUrl(ENDPOINTS.ORDERS.UPDATEORDER.replace(":orderId", orderId.toString())),
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to process order:", error);
      throw error;
    }
  }

  static async addOrderItemByAdmin(orderId: number, orderTotal: number, addedItems: any[],doctorName?:string) {
    try {
      console.log("\n\n addedItems: ", addedItems, "\n\n");
      const itemAddedByAdmin = {
        orderTotal: orderTotal,
        doctorName:doctorName,
        productOrderItems: addedItems.map((data: any) => {
          return {
            productId: data?.product_id,
            productPrice: data?.landing_cost,
            numberOfItems: data?.selectedQuantity,
            mrp:data?.mrp
          };
        }),
      };

      const response = await fetch(
        getFullUrl(ENDPOINTS.ORDERS.ADDORDERITEMBYADMIN.replace(":orderId", orderId.toString())),
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.getToken()}`,
          },
          body: JSON.stringify(itemAddedByAdmin),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to process order:", error);
      throw error;
    }
  }

  static async fetchNotificationTokens(userId: string) {
    try {
      const url = `${getFullUrl(ENDPOINTS.AUTH.FETCHUSERNOTIFICATIONTOKEN)}?id=${userId}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      const json = await response.json();

      if (!json.success) {
        return {
          success: false,
          message: json.message || "Failed to fetch notification tokens",
        };
      }

      // Deduplicate based on notificationToken
      const uniqueTokens = Array.from(
        new Set(json.data.map((item: { notificationToken: unknown }) => item.notificationToken))
      );
      return uniqueTokens.join(",");
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error ? error.message : "Failed to fetch notification tokens of doctor",
      };
    }
  }

  static async sendNotification(title: string, message: string, token: string) {
    try {
      const url = getFullUrl(ENDPOINTS.NOTIFICATION.SEND_NOTIFICATION);
      const body = {
        title,
        message,
        tokens: [token],
      };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      return data;
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Notification sending failed",
      };
    }
  }

 static async getAllMedicines(searchText: string = "") {
    try {
      const params = new URLSearchParams({
        searchText,
      });

      const url = `${getFullUrl(ENDPOINTS.MEDICINE.GETALLMEDICINES)}?${params.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (response.status === 401) {
        return {
          success: "invalid",
          message: "Session expired. Please log in again.",
        };
      }
      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Failed to fetch medicines",
      };
    }
  }

  static async getDashboardOverview() {
    try {
      const url = `${getFullUrl(ENDPOINTS.INVENTORY.DASHBOARDOVERVIEW)}`;
      console.log("dashboard url", url);
      const response = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      if (response.status === 401) {
        return {
          success: "invalid",
          message: "Session expired. Please log in again.",
        };
      }
      const res = await response.json();
      console.log("dashboard response", res);
      return res;
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Failed to fetch medicines",
      };
    }
  }

  static async cancleOrder(orderId: string) {
    try {
      const url = `${getFullUrl(
        ENDPOINTS.ORDERS.CANCEL_ORDER.replace(":orderId", orderId.toString())
      )}`;

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify({ status: "CANCELLED" }),
      });

      if (response.status === 401) {
        return {
          success: "invalid",
          message: "Session expired. Please log in again.",
        };
      }
      console.log("dashboard response", response.json());
      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Failed to fetch medicines",
      };
    }
  }

 static async cancelOrder(orderId: number | string, cancelationReason: string = "", cancelledBy: string = "patient") {
    try {
      const url = getFullUrl("/orderservice/online-order/cancel-order");

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify({
          orderId: Number(orderId),
          cancelledBy: cancelledBy || "patient",
          cancelationReason: cancelationReason || "Order cancelled",
        }),
      });

      const data = await response.json();

      if (response.status === 401) {
        return {
          success: false,
          message: "Session expired. Please log in again.",
          isAuthError: true,
        };
      }

      if (!response.ok) {
        return {
          success: false,
          message: data.message || "Failed to cancel order",
        };
      }

      return {
        success: true,
        message: data.message || "Order cancelled successfully",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Failed to cancel order",
      };
    }
  }
}
